import PostJob from "../PostJob/PostJob";

const PostJobPage=()=>{
    return(
        <div className="min-h-screen bg-mine-shaft-950 font-['poppins'] p-4">
        <PostJob/>
        </div>
    ) 
}
export default PostJobPage;